export default __webpack_public_path__ + "static/media/newSet1-2-min.1eb89e31.png";